module.exports = __webpack_public_path__ + "img/242.b27707f5.jpg";